export default "__VITE_ASSET__CVH6VxKU__"